<template>
  <main class="main">
    <agile :arrows="false" :speed="750"
           :timing="'linear'" :fade="true"
           :autoplay="false" :pauseOnHover="false">
      <div class="slide slide--1" v-bind:style="{height: pageHeight + 'px'}">
        <div class="mainbox">
          <parallax-container>
            <parallax-element :parallaxStrength="-5" :type="'translation'"
                              v-bind:style="(myWidth > 768) ? {'marginTop': + pageHeight*2/3 + 'px'} : {'marginTop': + (pageHeight-210) + 'px'}">
              <h3 class="cit"
                  style="color: white; position: relative; -webkit-animation: moving 15s infinite; padding-right: 20px; animation: moving 15s infinite">
                {{$t("cit")}}</h3>
              <div class="col-lg-offset-5 col-lg-12 autore"
                   style="position: relative; -webkit-animation: moving 15s infinite; animation: moving 15s infinite">
                Robert Louis Stevenson
              </div>
            </parallax-element>
          </parallax-container>
        </div>
        <section id="section05" class="demo" v-if="pageHeight > 500">
          <a><span @click="scroll"></span></a>
        </section>
        <section id="section06" class="demo" v-if="pageHeight > 500">
          <a><span @click="scroll"></span></a>
        </section>
      </div>
      <div class="slide slide--2" v-bind:style="{height: pageHeight + 'px'}">
        <section id="section05" class="demo" v-if="pageHeight > 500">
          <a><span></span></a>
        </section>
        <section id="section06" class="demo" v-if="pageHeight > 500">
          <a><span></span></a>
        </section>
      </div>
      <div class="slide slide--3" v-bind:style="{height: pageHeight + 'px'}">
        <section id="section05" class="demo" v-if="pageHeight > 500">
          <a><span></span></a>
        </section>
        <section id="section06" class="demo" v-if="pageHeight > 500">
          <a><span></span></a>
        </section>
      </div>
      <div class="slide slide--4" v-bind:style="{height: pageHeight + 'px'}">
        <section id="section05" class="demo" v-if="pageHeight > 500">
          <a><span></span></a>
        </section>
        <section id="section06" class="demo" v-if="pageHeight > 500">
          <a><span></span></a>
        </section>
      </div>
      <div class="slide slide--5" v-bind:style="{height: pageHeight + 'px'}">
        <section id="section05" class="demo" v-if="pageHeight > 500">
          <a><span></span></a>
        </section>
        <section id="section06" class="demo" v-if="pageHeight > 500">
          <a><span></span></a>
        </section>
      </div>
    </agile>
  </main>
</template>

<script>
  export default {
    name: 'mainslider',
    data() {
      return {
        myWidth: window.innerWidth
      }
    },
    props: {
      pageHeight: {
        type: Number,
        required: true,
        default: 700
      }
    },
    i18n: {
      fallbackLocale: 'it', // default lang,
      messages: {
        it: {
          cit: '"Il vino è poesia imbottigliata"'
        },
        en: {
          cit: '"Wine is bottled poetry"'
        }
      }
    },
    methods: {
      scroll: function () {
        this.$emit('scroll')
      }
    }
  }
</script>

<style lang="less">
  @import "../assets/less/variabili.less";
  @import "../assets/less/font.less";

  .demo a {
    position: absolute;
    bottom: 20px;
    width: 100%;
    //left: 50%;
    z-index: 2;
    display: block;
    -webkit-transform: translate(0, -50%);
    transform: translate(0, -50%);
    color: #fff;
    font: normal 400 20px/1 'Josefin Sans', sans-serif;
    letter-spacing: .1em;
    text-decoration: none;
    transition: opacity .3s;
  }

  .demo a:hover {
    opacity: .5;
  }

  #section05 a {
    padding-top: 70px;
  }

  #section05 a span {
    position: absolute;
    top: 0;
    left: 50%;
    width: 30px;
    height: 30px;
    margin-left: -12px;
    border-left: 3px solid #fff;
    border-bottom: 3px solid #fff;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    -webkit-animation: sdb05 1.5s infinite;
    animation: sdb05 1.5s infinite;
    box-sizing: border-box;
  }

  #section06 a {
    padding-top: 60px;
  }

  #section06 a span {
    position: absolute;
    top: 0;
    left: 50%;
    width: 30px;
    height: 30px;
    margin-left: -12px;
    border-left: 3px solid #fff;
    border-bottom: 3px solid #fff;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    -webkit-animation: sdb05 1.5s infinite;
    animation: sdb05 1.5s infinite;
    box-sizing: border-box;
  }

  #section07 a {
    padding-top: 80px;
  }

  #section07 a span {
    position: absolute;
    top: 0;
    left: 50%;
    width: 30px;
    height: 30px;
    margin-left: -12px;
    border-left: 3px solid #fff;
    border-bottom: 3px solid #fff;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    -webkit-animation: sdb05 1.5s infinite;
    animation: sdb05 1.5s infinite;
    box-sizing: border-box;
  }

  @-webkit-keyframes sdb05 {
    0% {
      -webkit-transform: rotate(-45deg) translate(0, 0);
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      -webkit-transform: rotate(-45deg) translate(-20px, 20px);
      opacity: 0;
    }
  }

  @keyframes sdb05 {
    0% {
      transform: rotate(-45deg) translate(0, 0);
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      transform: rotate(-45deg) translate(-20px, 20px);
      opacity: 0;
    }
  }

  @-webkit-keyframes sdb06 {
    0% {
      -webkit-transform: rotateY(0) rotateZ(-45deg) translate(0, 0);
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      -webkit-transform: rotateY(720deg) rotateZ(-45deg) translate(-20px, 20px);
      opacity: 0;
    }
  }

  @keyframes sdb06 {
    0% {
      transform: rotateY(0) rotateZ(-45deg) translate(0, 0);
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      transform: rotateY(720deg) rotateZ(-45deg) translate(-20px, 20px);
      opacity: 0;
    }
  }

  :focus {
    outline: none !important;
  }

  .main {
    z-index: 1;
    .agile {
      text-align: center;
      .mainbox {
        text-align: right;
        padding-right: 50px;
      }
      .cit {
        //margin-top: 30%;
        .set-font-CardoItalic()
      }
      .autore {
        .set-font-title(@size: 26px);
      }
      .agile__dots {
        bottom: 0;
        display: inherit;
        padding: initial;
        // left: 48%;
        position: absolute;
        width: 100%;
        margin-left: auto;
        margin-right: auto;
      }
      .agile__dot {
        padding: 5px;
        margin-bottom: 10px;
        display: inline-block;
        button {
          background-color: transparent;
          border: 1px solid #fff;
          margin-top: 10px;

          &:hover {
            background-color: #fff;
          }
        }

        &.agile__dot--current {
          button {
            background-color: #fff;
          }
        }
      }
    }
    .slide {
      background-position: center;
      background-size: cover;
      &.slide--1 {
        background-image: url("../../static/image/poesia.jpg");
      }
      &.slide--2 {
        background-image: url("../../static/image/2.jpg");
      }
      &.slide--3 {
        background-image: url("../../static/image/3.jpg");
      }
      &.slide--4 {
        background-image: url("../../static/image/4.jpg");
      }
      &.slide--5 {
        background-image: url("../../static/image/1.jpg");
      }
    }
  }

  @media (max-width: 767px) {
    #section05 {
      display: none;
    }

    .main {
      .agile {
        .mainbox {
          text-align: center;
          padding-right: 5px;
        }
        .cit {
          //margin-top: 60%;
          .set-font-CardoItalic()
        }
        .autore {
          padding-right: 20px;
          .set-font-title(@size: 23px);
        }
        .agile__dots {
          //left: 35%;
        }
        .agile__dot {
          padding: 3px;
          button {
          }

          &.agile__dot--current {
            button {
            }
          }
        }
      }
    }
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    .main {
      .agile {
        .cit {
          //margin-top: 70%;
          .set-font-CardoItalic()
        }
        .autore {
          padding-right: 20px;
          .set-font-title(@size: 37px);
        }
        .agile__dots {
        }
        .agile__dot {
          button {
          }

          &.agile__dot--current {
            button {
            }
          }
        }
      }
    }
  }

  @media (min-width: 1025px) and (max-width: 1366px) {
    .main {
      .agile {
        .cit {
          //margin-top: 70%;
          .set-font-CardoItalic()
        }
        .autore {
          padding-right: 20px;
          .set-font-title(@size: 37px);
        }
        .agile__dots {
        }
        .agile__dot {
          button {
          }

          &.agile__dot--current {
            button {
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/MainSlider.vue